import React, { useState, useEffect } from "react";
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import { FaGripVertical } from "react-icons/fa6";
import { ListGroup, Offcanvas, Spinner } from "react-bootstrap";
import { studyLevelFormManagementServices } from "../../../../APIServices/studyLevelFormManagementServices";
import { useParams } from "react-router";

const ManageFormOrder = ({ Show, Hide, Title, getStudyLevelForm }) => {
  const [orderedRows, setOrderedRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const { studyId } = useParams()
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const LoginCat = JSON.parse(localStorage.getItem("role")).toLowerCase();

  const getStudyLevelFormList = async (e) => {
    setLoading(true);
    let data = await studyLevelFormManagementServices.getStudyLevelForm(
      studyId,
      LoginCat,
      "active",
      StudyMode
    );
    setOrderedRows(data?.data || []);
    setLoading(false);
  };

  useEffect(() => {
    getStudyLevelFormList()
  }, []);

  const onDragEnd = async (result) => {
    if (!result.destination) return;
    const reordered = [...orderedRows];
    const [removed] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, removed);
    setOrderedRows(reordered);
    const indexing = reordered?.map((item, index) => ({
      formId: item.formId,
      formVersion: item.formVersion,
      index: index,
    }));
    let userData = {
      studyId: studyId,
      indexing: indexing,
    };
    let resultIndex = await studyLevelFormManagementServices.updateStudyLevelFormOrderData(
      userData
    );
    if (resultIndex?.statusCode === 200) {
      getStudyLevelForm();
      getStudyLevelFormList()
    }
  };

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end" style={{ width: 520 }}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="p-3">
        {loading ? (
          <div className="d-flex justify-content-center py-4">
            <Spinner animation="border" size="sm" />
          </div>
        ) : orderedRows?.length === 0 ? (
          <div className="text-muted">No forms found.</div>
        ) : (
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="manage-form-order" type="ROW">
              {(provided) => (
                <ListGroup ref={provided.innerRef} {...provided.droppableProps} className="border-0">
                  {orderedRows.map((row, index) => (
                      <Draggable key={row?._id} draggableId={row?._id} index={index}>
                        {(draggableProvided, snapshot) => (
                          <ListGroup.Item
                            ref={draggableProvided.innerRef}
                            {...draggableProvided.draggableProps}
                            className={`d-flex justify-content-between align-items-start gap-2 py-2 ${snapshot.isDragging ? "shadow" : ""}`}
                          >
                            <div className="d-flex gap-2">
                              <div
                                {...draggableProvided.dragHandleProps}
                                className="text-muted mt-1"
                                style={{ cursor: "grab" }}
                              >
                                <FaGripVertical size={10} />
                              </div>
                              <div>
                                <small className="fw-semibold">{row?.formName}</small>
                                <div className="text-muted small">Form Code: {row?.formCode}</div>
                              </div>
                            </div>
                            <span className="text-muted small">#{index + 1}</span>
                          </ListGroup.Item>
                        )}
                      </Draggable>
                  ))}
                  {provided.placeholder}
                </ListGroup>
              )}
            </Droppable>
          </DragDropContext>
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default ManageFormOrder;